import { observer } from "mobx-react"
import { useUserListStore } from "contexts/RootStore.context"
import ShowMoreButton from "components/DataTable/components/ShowMoreButton"
import { Column, DataTable } from "components/DataTable/DataTable";
import { User } from "types/userInfo";
import LocationCellRecentUser from "./LocationCellRecentUser";
import RecentUsersLastSeenCell from "./RecentUsersLastSeenCell";
import { Tooltip } from "components/Tooltip";
import { Horizontal } from "gls";
import { icons } from 'assets/icons/index'

const recentUsersColumns: Column<User>[] = [
  {
    title: 'NAME',
    field: "name",
    noSort: true
  },
  {
    title: 'LOCATION',
    renderer: (cellValue, row: User) => <LocationCellRecentUser user={row} />,
    field: 'region_name',
  },
  {
    title: 'LAST SEEN',
    renderer: (cellValue: any) => <RecentUsersLastSeenCell timestamp={cellValue} />,
    field: 'last_update_timestamp',
    sortField: "last_update"
  },
  {
    title: "",
    field: 'email',
    noSort: true,
    width: '15px',
    renderer: (cellValue: any) => <Tooltip infoIconContent>
      <Horizontal spacing={10}>
        <icons.EmailIcon aria-label="Email" />
        <span>{cellValue || "--"}</span>
      </Horizontal>
    </Tooltip>
  },
];

export const UserDataTable = observer(() => {

  const {
    usersList, loading, loadUsers, nextCount, getEmptyListMsg, onSort
  } = useUserListStore()

  return (
    <DataTable<User>
      loading={loading}
      columns={recentUsersColumns}
      data={usersList}
      emptyListMsg={getEmptyListMsg}
      onSort={onSort}
      renderLoadMore={nextCount > 0 && (
        <ShowMoreButton
          fetchFunction={() => loadUsers()}
          nextIsLoading={loading}
          nextCount={nextCount}
        />
      )}
    />
  )
})